import { z } from 'zod';
import { AggregationTypeSchema, CostCategorySchema, createPaginatedResponseSchema, IdParamsSchema, MetadataSchema, PaginationQuerySchema, SignalStatusSchema, SignalTypeSchema, } from '../common/index.js';
export const SignalSchema = z.object({
    id: z.string(),
    tenant_id: z.string(),
    environment_id: z.string(),
    signal_name: z.string().min(1).max(100),
    signal_code: z.string().min(1),
    description: z.string().nullable().optional(),
    signal_type: SignalTypeSchema,
    aggregation_type: AggregationTypeSchema,
    unit_label: z.string().default('units'),
    status: SignalStatusSchema,
    metadata: MetadataSchema,
    created_at: z.string().datetime(),
    updated_at: z.string().datetime(),
});
export const CostSignalConfigSchema = z.object({
    signal_id: z.string(),
    tenant_id: z.string(),
    environment_id: z.string(),
    fixed_cost_cents: z.number().int().nullable().optional(),
    cost_category: CostCategorySchema.nullable().optional(),
    created_at: z.string().datetime(),
    updated_at: z.string().datetime(),
});
export const CreateSignalSchema = z.object({
    signal_name: z.string().min(1).max(100),
    signal_code: z.string().min(1).max(100),
    description: z.string().max(500).nullable().optional(),
    signal_type: SignalTypeSchema,
    aggregation_type: AggregationTypeSchema.default('count'),
    unit_label: z.string().max(50).default('units'),
    status: SignalStatusSchema.default('active'),
    metadata: MetadataSchema.optional(),
    cost_config: z
        .object({
        fixed_cost_cents: z.number().int().min(0).nullable().optional(),
        cost_category: CostCategorySchema.nullable().optional(),
    })
        .optional(),
});
export const UpdateSignalSchema = z.object({
    signal_name: z.string().min(1).max(100).optional(),
    signal_code: z.string().min(1).max(100).optional(),
    description: z.string().max(500).optional().nullable(),
    aggregation_type: AggregationTypeSchema.optional(),
    unit_label: z.string().max(50).optional(),
    status: SignalStatusSchema.optional(),
    metadata: MetadataSchema.optional(),
    cost_config: z
        .object({
        fixed_cost_cents: z.number().int().min(0).optional().nullable(),
        cost_category: CostCategorySchema.optional().nullable(),
    })
        .optional(),
});
export const SignalResponseSchema = SignalSchema.extend({
    cost_config: CostSignalConfigSchema.pick({
        fixed_cost_cents: true,
        cost_category: true,
    }).optional(),
});
export const SignalQuerySchema = PaginationQuerySchema.extend({
    signal_type: SignalTypeSchema.optional(),
    aggregation_type: AggregationTypeSchema.optional(),
    status: SignalStatusSchema.optional(),
    search: z.string().optional(),
});
export const PaginatedSignalsResponseSchema = createPaginatedResponseSchema(SignalResponseSchema);
export const SignalParamsSchema = IdParamsSchema;
//# sourceMappingURL=index.js.map